import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ForgotPasswordForm from "./ForgotPasswordForm";
import ResetPassword from "./ResetPassword";
import ExpiredPage from "./ExpiredPage";
import { getLocale } from "../common/properties";
import {
  createResetPasswordPayload,
  resetPasswordAction,
} from "../utils/index";

interface ForgotPasswordProps {
  siteKey?: string;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = (
  props: ForgotPasswordProps
) => {
  const { siteKey } = props;

  const [params] = useSearchParams();
  const targetUrl = params.get("target"); //for forgotpassword
  const token = params.get("token"); // for resetpassword
  const locale = getLocale();
  const [loading, setLoading] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [resetTargetUrl, setResetTargetUrl] = useState<string | null>(null);
  const handleResetPasswordSuccess = (targetUrl: string | null) => {
    setResetTargetUrl(targetUrl);
  };
  useEffect(() => {
    const fetchData = async () => {
      if (token) {
        const timeStampCheckPayload = createResetPasswordPayload("", token, "");
        try {
          const response = await resetPasswordAction(timeStampCheckPayload);
          if (response?.result?.errors?.length > 0) {
            setIsValid(false);
          } else {
            setIsValid(true);
          }
        } catch (error) {
          console.error("API call failed:", error);
          setIsValid(false);
        }
      }
      setLoading(false);
    };

    fetchData();
  }, [params]);
  const renderContent = () => {
    if (loading) {
      return <div></div>;
    }
    if (token) {
      return isValid ? (
        <ResetPassword
          encryptedData={token}
          onResetSuccess={handleResetPasswordSuccess}
          siteKey={siteKey}
        />
      ) : (
        <ExpiredPage />
      );
    } else {
      return (
        <ForgotPasswordForm
          locale={locale}
          targetUrl={targetUrl}
          resetTargetUrl={resetTargetUrl}
          siteKey={siteKey}
        />
      );
    }
  };
  return <div className="main-page-container container">{renderContent()}</div>;
};

export default ForgotPassword;
